import { mapGetters } from 'vuex'
// eslint-disable-next-line no-unused-expressions

export const navMenu = {
  computed: {
    ...mapGetters(['get_navmenu_item_data'])
  },
  data () {
    return {
      dynamic: [
        {
          url: '/teacher/dashboard',
          name: 'Dashboard',
          slug: 'Dashboard',
          icon: 'dashboard'
        }
      ]
    }
  },
  mounted () {
    // this.fetch_accessible_module_list();
    const rolePermission = parseInt(localStorage.getItem('role_permission'))

    if (rolePermission != 1) {

      this.creatingNavMenu()

    }
  },
  // beforeRouteEnter (to, from, next){
  //
  //     // this.creatingNavMenu()
  //     next()
  // },
  methods: {
    hasViewPermissionEnabled (permissionInfo) {
      let hasPermissionView = false
      permissionInfo.action_list.forEach(element => {
        if ((element.action_name === 'View' || element.action_name === 'ViewOwn' || element.action_name === 'getInvoicesList' || element.action_name === 'Student permission' || element.action_name === 'Teacher permission' || element.action_name === 'Room view' || element.action_name === 'cancelSchedule' || element.action_name === 'Reschedule Session' || element.action_name === 'StudentClassScheduleView' || element.action_name === 'TeacherClassScheduleView') && element.enabled === 1) {
          hasPermissionView = true
        }
      })

      if (hasPermissionView) {
        return true
      } else {
        return false
      }
    },

    hasCreatePermissionEnabled (permissionInfo) {
      //
      //
      let hasPermissionView = false
      permissionInfo.action_list.forEach(element => {
        if (element.action_name === 'Create' && element.enabled === 1) {
          hasPermissionView = true
        }
      })

      if (hasPermissionView) {
        return true
      } else {
        return false
      }
    },

    hasCustomModuleView (permissionInfo, permissionAction) {
      let hasPermissionView = false
      permissionInfo.action_list.forEach(element => {
        if (element.action_name === permissionAction && element.enabled === 1) {
          hasPermissionView = true
        }
      })

      if (hasPermissionView) {
        return true
      } else {
        return false
      }

    },
    // hasViewEmailEnable (permissionInfo) {
    //   let hasPermissionView = false
    //   permissionInfo.action_list.forEach(element => {
    //     if (element.action_name === 'ViewEmail' && element.enabled === 1) {
    //       hasPermissionView = true
    //     }
    //   })
    //
    //   if (hasPermissionView) {
    //     return true
    //   } else {
    //     return false
    //   }

    // },

    // hasViewSmsTemplate (permissionInfo) {
    //   let hasPermissionView = false
    //   permissionInfo.action_list.forEach(element => {
    //     if (element.action_name === 'ViewSmsTemplate' && element.enabled === 1) {
    //       hasPermissionView = true
    //     }
    //   })
    //
    //   if (hasPermissionView) {
    //     return true
    //   } else {
    //     return false
    //   }

    // },


    communicationPermissionAccess (item, communicationMenu) {
      const filterAccess = item.action_list.filter(function (currentElement) {
        return currentElement.enabled === 1
      })

      filterAccess.find(object => {
        if (object.action_name === 'compose') {
          communicationMenu.submenu.push({
            url: '/pages/email',
            name: 'Email',
            slug: 'Email',
            icon: 'email',
            i18n: 'Email'
          })
        }
      })

      filterAccess.find(object => {
        if (object.action_name === 'viewPushTemplate') {
          communicationMenu.submenu.push({
            url: '/pages/notification',
            name: 'Notification',
            slug: 'Notification',
            icon: 'notifications',
            i18n: 'Notification'
          })
        }
      })

      filterAccess.find(object => {
        if (object.action_name === 'viewNotification') {
          const checkSubmenu = communicationMenu.submenu.filter(function (currentElement) {
            return currentElement.name === 'Notification'
          })

          if (checkSubmenu.length === 0) {
            communicationMenu.submenu.push({
              url: '/pages/notification',
              name: 'Notification',
              slug: 'Notification',
              icon: 'notifications',
              i18n: 'Notification'
            })
          }
        }
      })

      filterAccess.find(object => {
        if (object.action_name === 'SendSms') {
          communicationMenu.submenu.push(
            { url: '/pages/sms',
              name: 'SMS',
              slug: 'SMS',
              icon: 'sms',
              i18n: 'SMS'
            }
          )
        }
      })

      filterAccess.find(object => {
        if (object.action_name === 'View') {
          communicationMenu.submenu.push({
            url: '/pages/blogs-post',
            name: 'Blogs and posts',
            slug: 'Blogs and posts',
            icon: 'article',
            i18n: 'Blogs and posts'
          })
        }
      })

      filterAccess.find(object => {
        if (object.action_name === 'sendChat') {
          communicationMenu.submenu.push({
            url: '/pages/chat',
            name: 'Chat',
            slug: 'Chat',
            icon: 'question_answer',
            i18n: 'Chat'
          })
        }
      })
      /* for (let index = 0; index < filterAccess.length; index++) {
        if (filterAccess[index].action_name === 'compose') {
          communicationMenu.submenu.push({
            url: '/pages/email',
            name: 'Email',
            slug: 'Email',
            icon: 'email',
            i18n: 'Email'
          })
        } else if (filterAccess[index].action_name === 'SendSms') {
          communicationMenu.submenu.push(
            { url: '/pages/sms',
              name: 'SMS',
              slug: 'SMS',
              icon: 'sms',
              i18n: 'SMS'
            }
          )
        } else if (filterAccess[index].action_name === 'communicationSetting') {
          communicationMenu.submenu.push({
            url: '/pages/communication/settings',
            name: 'Settings',
            slug: 'Settings',
            icon: 'settings',
            i18n: 'Settings'
          })
        } else if (filterAccess[index].action_name === 'View') {
          communicationMenu.submenu.push({
            url: '/pages/blogs-post',
            name: 'Blogs and posts',
            slug: 'Blogs and posts',
            icon: 'article',
            i18n: 'Blogs and posts'
          })
        } else if (filterAccess[index].action_name === 'sendChat') {
          communicationMenu.submenu.push({
            url: '/pages/chat',
            name: 'Chat',
            slug: 'Chat',
            icon: 'question_answer',
            i18n: 'Chat'
          })
        } else if (filterAccess[index].action_name === 'viewPushTemplate') {
          communicationMenu.submenu.push({
            url: '/pages/notification',
            name: 'Notification',
            slug: 'Notification',
            icon: 'notifications',
            i18n: 'Notification'
          })
        } else if (filterAccess[index].action_name === 'viewNotification') {
          const checkSubmenu = communicationMenu.submenu.filter(function (currentElement) {
            return currentElement.name === 'Notification'
          })
          if (checkSubmenu.length === 0) {
            communicationMenu.submenu.push({
              url: '/pages/notification',
              name: 'Notification',
              slug: 'Notification',
              icon: 'notifications',
              i18n: 'Notification'
            })
          }
        }
      } */
    },
    settingsPermissionAccess (item, settingsMenu) {
      const filterAccess = item.action_list.filter(function (currentElement) {
        return currentElement.enabled === 1
      })

      filterAccess.find(object => {
        if (object.action_name === 'TagManagement') {
          settingsMenu.submenu.push({
            url: '/pages/tags',
            name: 'Tag Management',
            slug: 'Tags',
            icon: 'local_offer',
            i18n: 'TagManagement'
          })
        }
      })

      filterAccess.find(object => {
        if (object.action_name === 'ModuleCustomization') {
          settingsMenu.submenu.push({
            url: '/pages/customvaluesettings',
            slug: 'custom-value-settings',
            name: 'Module Customization',
            icon: 'settings',
            i18n: 'ModuleCustomization'
          })
        }
      })

      filterAccess.find(object => {
        if (object.action_name === 'StatusManagement') {
          settingsMenu.submenu.push({
            url: '/pages/statusmanagement',
            name: 'Status Management',
            icon:'settings',
            slug: 'status-management',
            i18n: 'StatusManagement'
          })
        }
      })

      filterAccess.find(object => {
        if (object.action_name === 'RoleManagement') {
          settingsMenu.submenu.push({
            url: '/pages/rolemanagement',
            name: 'Roles Management',
            icon:'settings',
            slug: 'role-management',
            i18n: 'RoleManagement'
          })
        }
      })

      filterAccess.find(object => {
        if (object.action_name === 'Communication') {
          settingsMenu.submenu.push({
            url: '/pages/communication/settings',
            name: 'Settings',
            slug: 'Communication Settings',
            icon: 'settings',
            i18n: 'Communication'
          })
        }
      })

      filterAccess.find(object => {
        if (object.action_name === 'SiteSetting') {
          settingsMenu.submenu.push({
            url: '/pages/settings',
            name: 'Setting',
            icon:'settings',
            slug: 'settings-management',
            i18n: 'Settings'
          })
        }
      })
    },
    creatingNavMenu () {
      /**
       * Navigation Menu order is maintained by the backend response order
       * It is done in order to maintain the same sequence as that for root admin
       */

      const attendanceMenu = {
        url: null,
        name: 'Attendance',
        icon: 'beenhere',
        i18n: 'Attendance',
        submenu: []
      }

      //education Main Menu
      const educationMenu = {
        url: null,
        name: 'Education',
        icon: 'school',
        i18n: 'Education',
        submenu: []
      }

      const communicationMenu = {
        url: null,
        name: 'Communication',
        icon: 'campaign',
        i18n: 'Communication',
        submenu: []
      }

      const facilityMenu = {
        url: null,
        name: 'Facilities',
        icon: 'maps_home_work',
        i18n: 'Facilities',
        submenu:[]
      }

      const graphAndAnalyticMenu = {
        url: null,
        name: 'Analytics ',
        icon: 'analytics',
        i18n: 'Analytics ',
        submenu:[]
      }

      const financeMenu = {
        url: null,
        name: 'Finance',
        slug: 'Finance',
        icon: 'savings',
        i18n: 'Finance',
        submenu:[]
      }

      const settingsMenu = {
        url: null,
        name: 'General Settings',
        icon: 'settings',
        i18n: 'GeneralSettings',
        submenu: []
      }

      let questionBuilderCount = 0
      const items = this.get_navmenu_item_data
      for (const item of items) {
        if (item.has_permission) {
          if (item.module_name === 'CRM') {
            const viewEnabled = this.hasViewPermissionEnabled(item)
            if (viewEnabled) {
              const __temp = {
                url: '/pages/leads',
                name: item.module_name,
                slug: 'CRM',
                icon: 'contacts'
              }
              this.dynamic.push(__temp)
            }
          } else if (item.module_name === 'Schedule') {
            const viewEnabled = this.hasViewPermissionEnabled(item)
            if (viewEnabled) {
              const __temp = {
                url: '/pages/schedule',
                name: item.module_name,
                slug: 'Schedule',
                icon: 'event'
              }
              this.dynamic.push(__temp)
            }
          } else if (item.module_name === 'Admission') {
            const viewEnabled = this.hasViewPermissionEnabled(item)
            if (viewEnabled) {
              const __temp = {
                url: '/pages/admission',
                name: item.module_name,
                slug: 'Admission',
                icon: 'supervised_user_circle'
              }
              this.dynamic.push(__temp)
            }
          }  else if (item.module_name === 'Files') {
            const viewEnabled = this.hasViewPermissionEnabled(item)
            if (viewEnabled) {
              const __temp = {
                url: '/pages/files',
                name: 'Material Files',
                slug: 'Files',
                icon: 'folder_special',
                i18n: 'Files'
              }
              this.dynamic.push(__temp)
            }
          } else if (item.module_name === 'Teachers') {
            const viewEnabled = this.hasViewPermissionEnabled(item)
            if (viewEnabled) {
              const __temp = {
                url: '/staff',
                name: 'Staff',
                slug: 'CRM',
                icon: 'badge'
              }
              this.dynamic.push(__temp)
            }
          } else if (item.module_name === 'Class') {
            const viewEnabled = this.hasCustomModuleView(item, 'View')
            if (viewEnabled) {
              educationMenu.submenu.push({
                url: '/pages/classes',
                name: 'Classes',
                slug: 'Classes',
                icon: 'groups',
                i18n: 'Classes'
              })
            }
          } else if (item.module_name === 'Grade') {
            // const viewEnabled = this.hasCustomModuleView(item, 'View')
            const viewEnabled = item.enabled
            if (viewEnabled) {
              educationMenu.submenu.push({
                url: '/pages/grade',
                name: 'Grade',
                slug: 'Grade',
                icon: 'star_outline',
                i18n: 'Grade'
              })
            }
          } else if (item.module_name === 'Notes') {
            const viewEnabled = item.enabled
            if (viewEnabled) {
              educationMenu.submenu.push({
                url: '/pages/notes',
                name: 'Notes',
                slug: 'Notes',
                icon: 'description',
                i18n: 'Notes'
              })
            }
          } else if (item.module_name === 'Course') {
            // hasCreatePermissionEnabled
            // const viewCreated = this.hasCreatePermissionEnabled(item)


            /* if (viewCreated) {
              educationMenu.submenu.push({
                url: '/pages/course-builder',
                name: 'Course Builder',
                slug: 'Course Builder',
                icon: 'collections_bookmark',
                i18n: 'Course Builder'
              })
            } */
            //checking it has view permission
            const viewEnabled = this.hasViewPermissionEnabled(item)

            if (viewEnabled) {
              educationMenu.submenu.push({
                url: '/pages/course-builder/course',
                name: 'Courses',
                slug: 'Courses',
                icon: 'collections_bookmark',
                i18n: 'Courses'
              })

              educationMenu.submenu.push({
                url: '/pages/lessonlist',
                name: 'Lessons',
                slug: 'Lessons',
                icon: 'class',
                i18n: 'Lessons'
              })
              educationMenu.submenu.push({
                url: '/pages/topiclist',
                name: 'Topics',
                slug: 'Lesson Lisitng',
                icon: 'topic',
                i18n: 'Topics'
              })

            }
          } else if (
            item.module_name === 'Tests & Exams'
          || item.module_name === 'Reports'
          || item.module_name === 'Coursework'
          || item.module_name === 'Question Bank'
          ) { //for QuestionBuilder create Permission //
            const createEnabled = this.hasCreatePermissionEnabled(item)

            if (createEnabled) {
              if (questionBuilderCount === 0) {
                educationMenu.submenu.push({
                  url: '/pages/questions-builder',
                  name: 'Question Bank V2',
                  slug: 'Question Bank V2',
                  icon: 'comment_bank',
                  i18n: 'Question Builder'
                })
              }

              questionBuilderCount++
            }
            if (item.module_name === 'Question Bank') {
              const viewEnabled = this.hasViewPermissionEnabled(item)

              if (viewEnabled) {
                educationMenu.submenu.push({
                  url: '/pages/questionbanklist',
                  name: 'Question Bank',
                  slug: 'Question Bank',
                  icon: 'comment_bank',
                  i18n: 'Question Bank'
                })
              }
            }
            if (item.module_name === 'Coursework') {
              const viewEnabled = this.hasViewPermissionEnabled(item)
              if (viewEnabled) {
                educationMenu.submenu.push({
                  url: '/pages/coursework',
                  name: item.module_name,
                  slug: 'Homework',
                  icon: 'bookmarks'
                })
              }
            }
            if (item.module_name === 'Reports') {
              const viewEnabled = this.hasViewPermissionEnabled(item)

              if (viewEnabled) {
                educationMenu.submenu.push({
                  url: '/pages/reports',
                  name: item.module_name,
                  slug: 'Reports',
                  icon: 'summarize'
                })
              }
            }
            if (item.module_name === 'Tests & Exams') {

              const viewEnabled = this.hasViewPermissionEnabled(item)

              if (viewEnabled) {
                educationMenu.submenu.push({
                  url: '/pages/exam',
                  name: item.module_name,
                  slug: 'Exams',
                  icon: 'rule'
                })
              }
            }
          }  else if (item.module_name === 'Students') {
            const viewEnabled = this.hasViewPermissionEnabled(item)

            if (viewEnabled) {
              const __temp = {
                url: '/clients',
                name: 'Students',
                slug: 'Students',
                icon: 'supervised_user_circle'
              }
              this.dynamic.push(__temp)
            }
          }  else if (item.module_name === 'Subject') {
            const viewEnabled = this.hasViewPermissionEnabled(item)

            if (viewEnabled) {
              const __temp = {
                url: '/pages/subjects',
                name: 'Subjects',
                slug: 'Subjects',
                icon: 'bookmarks',
                i18n: 'Subjects'
              }
              educationMenu.submenu.push(__temp)
            }
          }  else if (item.module_name === 'Tasks') {
            const viewEnabled = this.hasViewPermissionEnabled(item)
            if (viewEnabled) {
              const __temp = {
                url: '/pages/tasks-project',
                name: 'Tasks & Projects',
                slug: 'Tasks & Projects',
                icon: 'check_box'
              }
              this.dynamic.push(__temp)
            }
          } else if (item.module_name === 'Projects') {
            const viewEnabled = this.hasViewPermissionEnabled(item)
            if (viewEnabled) {
              const checkSubmenu = educationMenu.submenu.filter(function (currentElement) {
                return currentElement.name === 'Tasks & Projects'
              })
              if (checkSubmenu.length === 0) {
                const __temp = {
                  url: '/pages/tasks-project',
                  name: 'Tasks & Projects',
                  slug: 'Tasks & Projects',
                  icon: 'CheckSquareIcon'
                }
                this.dynamic.push(__temp)
              }
            }
          } else if (item.module_name === 'Subject') {
            const viewEnabled = this.hasViewPermissionEnabled(item)

            if (viewEnabled) {
              const __temp = {
                url: '/pages/subjects',
                name: 'Subjects',
                slug: 'Subjects',
                icon: 'bookmarks',
                i18n: 'Subjects'
              }
              educationMenu.submenu.push(__temp)
            }
          } else if (item.module_name === 'CourseFiles') {
            const __temp = {
              url: '/pages/files',
              name: 'Files',
              slug: 'Files',
              icon: 'folder_special'
            }
            this.dynamic.push(__temp)
          } else if (item.module_name === 'Setting') {
            const __temp = {
              url: '/pages/settings',
              name: item.module_name,
              slug: 'Setting',
              icon: 'settings'
            }
            this.dynamic.push(__temp)
          } else if (item.module_name === 'Finance') {
            const viewEnabled = this.hasCustomModuleView(item, 'getInvoicesList')


            if (viewEnabled) {
            /*   const __temp = {
                url: '/pages/finance',
                name: item.module_name,
                slug: 'Finance',
                icon: 'savings'
              } */

              financeMenu.submenu.push({
                url: '/pages/finance',
                name: 'Student Finance',
                slug: 'Finance',
                icon: 'savings'
              })
              if (parseInt(localStorage.getItem('role_permission')) == 1) {
                financeMenu.submenu.push({
                  url: '/pages/manual-invoice',
                  name: item.module_name,
                  slug: 'Manual Invoice',
                  icon: 'savings',
                  i18n: 'Manual Invoice'
                })
              }
              financeMenu.submenu.push({
                url: '/staffpayout',
                name: 'Staff Payment',
                slug: 'Staff Payment',
                icon: 'savings',
                i18n: 'Staff Payment'
              })


              // this.dynamic.push(__temp)
            }

            financeMenu.submenu.push({
              url: '/staffpaidslip',
              name: 'Staff Paid Slip',
              slug: 'Staff Paid Slip',
              icon: 'savings',
              i18n: 'Staff Paid Slip'
            })

            this.dynamic.push(financeMenu)

          } else if (item.module_name === 'Attendance') {


            const viewEnabled = this.hasCustomModuleView(item, 'fetchAttendance')


            if (viewEnabled) {
              attendanceMenu.submenu.push({
                url: '/pages/attendance',
                name: 'Student Attendance',
                slug: 'Student Attendance',
                icon: 'beenhere',
                i18n: 'Student Attendance'
              })

              attendanceMenu.submenu.push({
                url: '/pages/attendance-teacher',
                name: 'Teacher Attendance',
                slug: 'Teacher Attendance',
                icon: 'beenhere',
                i18n: 'Teacher Attendance'
              })
            }

          } else if (item.module_name === 'Referral/Loyalty') {
            const __temp = {
              url: '/pages/referrals',
              name: item.module_name,
              slug: 'Referral/Loyalty',
              icon: 'ActivityIcon'
            }
            this.dynamic.push(__temp)
          // } else if (item.module_name === 'Messaging') {
          //   const __temp = {
          //     url: '/pages/messaging',
          //     name: item.module_name,
          //     slug: 'Messaging',
          //     icon: 'MessageSquareIcon'
          //   }
          //   this.dynamic.push(__temp)
          } else if (item.module_name === 'Rooms and Inventory') {
            const viewListInventory = this.hasCustomModuleView(item, 'listInventory')
            const viewListRoom = this.hasCustomModuleView(item, 'listRoom')
            if (viewListRoom) {
              facilityMenu.submenu.push({
                url: '/pages/rooms',
                name: 'rooms',
                slug: 'rooms',
                icon: 'meeting_room',
                i18n: 'Rooms'
              })
            }

            if (viewListInventory) {
              facilityMenu.submenu.push({
                url: '/pages/inventory',
                name: 'inventory',
                slug: 'inventory',
                icon: 'inventory',
                i18n: 'Inventory'
              })

            }


          } else if (item.module_name === 'History') {
            const __temp = {
              url: '/pages/historylog',
              name: item.module_name,
              slug: 'History',
              icon: 'ListIcon'
            }
            this.dynamic.push(__temp)
          }  else if (item.module_name === 'Communication') {
            this.communicationPermissionAccess(item, communicationMenu)
          } else if (item.module_name === 'Analytics') {
            const viewGraphEnable = this.hasCustomModuleView(item, 'fetchGraphsList')
            if (viewGraphEnable) {
              graphAndAnalyticMenu.submenu.push({
                url: '/graph',
                slug: 'graph',
                name: 'Graph',
                icon: 'show_chart',
                i18n: 'Graph'
              })
            }

            const viewSummaryEnable = this.hasCustomModuleView(item, 'View')
            if (viewSummaryEnable) {
              graphAndAnalyticMenu.submenu.push({
                url: '/pages/summery-settings',
                name: 'Summery Settings',
                icon:'summarize',
                slug: 'summery-settings',
                i18n: 'Summary Settings'
              })
            }
          } else if (item.module_name === 'Certificates') {
            const viewEnabled = this.hasCustomModuleView(item, 'View')
            if (viewEnabled) {
              const __temp = {
                url: '/pages/certificate-listing',
                name: 'certificate-listing',
                slug: 'Certificates',
                icon: 'verified',
                i18n: 'Certificates'
              }
              educationMenu.submenu.push(__temp)
            }
          } else if (item.module_name === 'General Settings') {
            this.settingsPermissionAccess(item, settingsMenu)
          }
        }
      }

      /* financeMenu.submenu.push({
        url: '/staffpaidslip',
        name: 'Staff Paid Slip',
        slug: 'Staff Paid Slip',
        icon: 'savings',
        i18n: 'Staff Paid Slip'
      })
      if (financeMenu.submenu.length > 0) {
        this.dynamic.push(financeMenu)

      } */
      if (attendanceMenu.submenu.length > 0) {
        this.dynamic.push(attendanceMenu)
      }

      if (educationMenu.submenu.length > 0) {
        this.dynamic.push(educationMenu)
      }

      if (graphAndAnalyticMenu.submenu.length > 0) {
        this.dynamic.push(graphAndAnalyticMenu)
      }

      if (facilityMenu.submenu.length > 0) {
        this.dynamic.push(facilityMenu)
      }

      if (communicationMenu.submenu.length > 0) {
        this.dynamic.push(communicationMenu)
      }

      if (settingsMenu.submenu.length > 0) {
        this.dynamic.push(settingsMenu)
      }
    }
  }

}
